import request from '../../../utils/request';
import {paramSecret} from "../../../utils/commonSecret";

// 根据场景发送短信验证码带滑块验证码验证
export async function SendSmsCodeSlider(params, isH5 = false) {
    return request('/api/v1/business-server/member/sendsmscodeslider', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params, isH5)),
    })
}

// 人脸识别认证
export async function faceVerify(params,isH5=false) {
    return request('/api/v1/business-server/member/nonageRefund/faceVerify',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params,isH5)),
    })
}

// 人脸识别认证状态查询
export async function faceVerifyQuery(params,isH5=false) {
    return request('/api/v1/business-server/member/nonageRefund/faceVerifyQuery',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params,isH5)),
    })
}

// 退款申请提交
export async function faceVerifyLogAdd(params,isH5=false) {
    return request('/api/v1/business-server/member/nonageRefund/faceVerifyLogAdd',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params,isH5)),
    })
}

// 退款查询
export async function faceVerifyLogQuery(params,isH5=false) {
    return request('/api/v1/business-server/member/nonageRefund/faceVerifyLogQuery',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params,isH5)),
    })
}
